import { render, staticRenderFns } from "./tm-pay-page.vue?vue&type=template&id=a7585960&scoped=true&"
import script from "./tm-pay-page.vue?vue&type=script&lang=ts&"
export * from "./tm-pay-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-pay-page.vue?vue&type=style&index=0&id=a7585960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7585960",
  null
  
)

export default component.exports